module.exports = __webpack_public_path__ + "teg/media/courier.f17acd9c.jpg";